var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ComboHub"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-top": "-15px",
      "margin-bottom": "0rem"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "combo-hub-tabs-wrap",
    staticStyle: {
      "margin-top": "-10px",
      "padding": "0",
      "margin-bottom": "0rem"
    }
  }, [_c('div', {
    staticClass: "combo-hub-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n              " + _vm._s(tab.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    tag: "component",
    staticClass: "tab"
  })], 1)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "0px",
      "margin-top": "-5px"
    }
  }, [_c('legend', {
    staticStyle: {
      "font-size": "20px",
      "border": "0px"
    }
  }, [_vm._v("Combo Hub")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db5e24e6","hasScoped":true}!./src/views/components/AutoHandover_v1/AutoHandover_v1.html
// module id = 1797
// module chunks = 2